import "rxjs/add/operator/map";
import { WATERMARKING } from "constants/action-types";
import siteConfig from "site-config";
import { add as snackbarAdd } from "../actions/snackbars";
import { format } from "lib/globalize-util";
import { IWatermarking } from "reducers/watermarking";
import { IRequestAction, IRequestDataAction, progressEpic } from "./base-epic";
import { IStore } from "reducers";

export const fetchWatermarkingDetails = progressEpic<IRequestDataAction<IWatermarking>, IWatermarking>(
    WATERMARKING.FETCH,
    (action, store) => ({
        url: `${siteConfig.api}/brand/${store.scope.brand._id}/watermarking`,
        method: "GET",
    })
);

export const updateWatermarkingSettingsEpic = progressEpic<IRequestDataAction<IWatermarking>, IWatermarking>(
    WATERMARKING.UPDATE,
    ({ payload }, store) => ({
        body: payload,
        url: `${siteConfig.api}/brand/${store.scope.brand._id}/watermarking`,
        method: "POST",
    }),
    {
        dataCustomizer: (watermarking, action, store: IStore) => ({ ...store.watermarking.payload, ...watermarking }),
        finishActions: () => [snackbarAdd({ message: format("All changes saved") })],
    }
);

export const fetchWatermarkingPreviewEpic = progressEpic<IRequestAction, IWatermarking>(
    WATERMARKING.PREVIEW,
    () => ({
        url: `${siteConfig.api}/products/watermarking-image`,
        method: "GET",
    }),
    {
        dataCustomizer: (response, action, store: IStore) => ({
            ...store.watermarking.payload,
            previewImage: response.mediaUrl,
        }),
    }
);
